import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const publicCheckoutComContract = c.router(
  {
    processNotification: {
      method: 'POST',
      path: '/process-notification',
      body: z.any(),
      responses: {
        200: z.object({ notificationResponse: z.string() }),
        429: z.object({ notificationResponse: z.string() }),
      },
      summary: 'Webhook called by Checkout.com',
    },
  },
  {
    pathPrefix: '/public',
  },
);
